

































































































































































import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { YKDCenterDrawer } from 'gum-ui'
import moment from 'moment'
import {
  queryTopicBankList,
  distinctCustomType,
  queryTopicBank
} from '@/api/exam/topicBank'
import TopicBank from '@/model/exam/topicBank'
import Topic from '@/model/exam/topic'
interface TreeData extends TopicBank {
  key: string
  title: string
  scopedSlots: any
}
import { queryPagingTopic, queryAllTopic, queryTopics } from '@/api/exam/topic'
import { delHtmlTag } from '@/apps/exam/util/htmlUtil'
import TopicGroup, { TopicPart } from '@/model/exam/topicGroup'

import ExamPlan from '@/model/exam/examPlan'
@Component({
  components: { YKDCenterDrawer }
})
export default class FixedCreateTopicCenterDialog2 extends Vue {
  @Prop() centerDrawer?: boolean
  @Prop() private topicPart?: TopicPart
  @Prop() private localData?: any[]
  @Prop() private topicGroup?: TopicGroup
  private topicBanks: TopicBank[] = []
  private selectTopics: Topic[] = []
  private chosenTopics: Topic[] = []
  private errorText: string = 'color: #000000;'
  private selectNUmber: number = 0
  private checkList: any[] = []
  private keyword?: string = ''
  private topicBankTree!: TreeData[]
  private selectedKeys: string[] = []
  private expandedKeys: string[] = []
  private checkedDepartmentKeys: string[] = []
  private treeData: TopicBank[] = []
  private searchResultKeys: string[] = []
  private selectTopicId: string = ''
  private columns = [
    {
      title: '题目',
      dataIndex: 'name'
    }
  ]
  private selectedRowKeys: any[] = []
  private data: any[] = []
  async selectTreeNode(selectedKey: any[], e: any) {
    this.selectTopicId = selectedKey[0]
    if (selectedKey && selectedKey.length > 0) {
      // this.selectDepartment(selectedKey[0])
      this.selectedKeys = selectedKey
      this.expandedKeys = selectedKey

      // this.selectTopicBank(e.selectedNodes[0].data.props)
      this.selectedRowKeys = []
      const topics = await queryTopics({
        topicBankId: [e.selectedNodes[0].data.props.id]
      })

      this.data = []
      if (topics && topics && topics.length > 0) {
        this.selectTopics = topics
        topics.forEach((item, index) => {
          this.data.push({
            key: index,
            name: delHtmlTag(item.name!)
          })
        })
      }
    }
  }
  @Watch('centerDrawer')
  async initSelectData() {
    this.topicBanks = await queryTopicBankList(
      this.topicGroup!.topicCategory!,
      [],
      true
    )
    this.treeData = this.topicBanks
    this.selectedKeys = [this.treeData[0].id!]
    this.expandedKeys = [this.treeData[0].id!]
    await this.initTopicBank()
    this.data = []
    const topics = await queryTopics({
      topicBankId: [this.selectTopicId]
    })

    this.data = []
    if (topics && topics && topics.length > 0) {
      this.selectTopics = topics
      topics.forEach((item, index) => {
        this.data.push({
          key: index,
          name: delHtmlTag(item.name!)
        })
      })
    }
  }
  async initTopicBank() {
    this.topicBankTree = []
    this.initTree(this.topicBanks, this.topicBankTree)
    this.selectTopicId = this.topicBankTree[0].id!
  }
  initTree(items: TopicBank[], selectTreeData: TreeData[]) {
    items.map(node => {
      const item = {
        ...node,
        title: node.name + ' ' + '(' + node.customType + ')',
        key: node.id!,
        scopedSlots: {
          icon: 'custom',
          key: node.id,
          title: node.name + '(' + node.customType + ')',
          customType: node.customType,
          parentId: node.parentId
        }
      } as TreeData
      selectTreeData.push(item)
      if (node.children && node.children.length > 0) {
        item.children = []
        this.initTree(node.children, item.children as TreeData[])
      }
    })
    this.$forceUpdate()
  }

  async selectBank(topicBank: TopicBank) {
    this.selectedRowKeys = []
    const topics = await queryPagingTopic({
      topicBankId: topicBank.id,
      pageSize: 10000
    })

    this.data = []
    if (topics && topics.data && topics.data.length > 0) {
      this.selectTopics = topics.data
      topics.data.forEach((item, index) => {
        this.data.push({
          key: index,
          name: delHtmlTag(item.name!)
        })
      })
    }
  }
  onSelectChange(selectedRowKeys: any) {
    //判断是否超出已选择的数量
    if (
      Number(this.topicPart!.topicNumber!) <=
      Number(this.selectNUmber) + this.localData!.length
    ) {
      this.errorText = 'color:red;'
      return
    }
    if (Number(this.selectNUmber) + this.localData!.length === 0) {
      if (selectedRowKeys.length > Number(this.topicPart!.topicNumber!)) {
        this.errorText = 'color:red;'
        return
      }
    }
    if (selectedRowKeys && selectedRowKeys.length > 0) {
      if (this.selectTopics && this.selectTopics.length > 0) {
        this.selectTopics.forEach((item, index) => {
          item.name = delHtmlTag(item.name!)
          if (selectedRowKeys.indexOf(index) != -1) {
            this.chosenTopics.push(item)
          }
        })
      }
    }
    //去重
    let newChosenTopics: Topic[] = []

    for (var i = 0; i < this.chosenTopics.length; i++) {
      if (newChosenTopics.length > 0) {
        let isNew: boolean = false
        newChosenTopics.forEach((item, index) => {
          if (item.id === this.chosenTopics[i].id) {
            isNew = true
          }
        })
        if (!isNew) {
          this.chosenTopics[i].topicNumber = newChosenTopics.length + 1
          newChosenTopics.push(this.chosenTopics[i])
        }
      } else {
        this.chosenTopics[i].topicNumber = 1
        newChosenTopics.push(this.chosenTopics[i])
      }
    }
    this.chosenTopics = newChosenTopics
    this.selectNUmber = this.chosenTopics.length
    this.selectedRowKeys = selectedRowKeys
  }
  deleteTopic(topic: Topic) {
    if (this.chosenTopics && this.chosenTopics.length > 0) {
      this.chosenTopics.forEach((item, index) => {
        if (topic.id === item.id) {
          this.chosenTopics.splice(index, 1)
        }
      })

      this.chosenTopics.forEach((item, index) => {
        item.topicNumber = index + 1
      })
    }
    this.selectNUmber = this.chosenTopics.length

    if (
      this.selectNUmber <=
      Number(this.selectNUmber) + this.localData!.length
    ) {
      this.errorText = 'color: #000000;'
    }
    this.selectedRowKeys = []
  }
  //筛选
  async handleSearch(e: any) {
    if (e) {
      let newTopics: Topic[] = []
      this.selectTopics.forEach((item, index) => {
        if (item.name) {
          if (item.name.match(e)) {
            newTopics.push(item)
          }
        }
      })
      this.data = []
      for (let i = 0; i < newTopics.length; i++) {
        this.data.push({
          key: newTopics[i].id,
          name: newTopics[i].name
        })
      }
    } else {
      this.data = []
      for (let i = 0; i < this.selectTopics!.length; i++) {
        this.data.push({
          key: this.selectTopics![i].id,
          name: this.selectTopics![i].name
        })
      }
    }
  }
  clear() {
    this.errorText = 'color: #000000;'
    this.selectedRowKeys = []
    this.chosenTopics = []
    this.selectNUmber = this.chosenTopics.length
  }
  closeCenter() {
    this.selectedRowKeys = []
    this.selectNUmber = 0
    this.$emit('closeCenter')
  }
  openCenter() {
    this.$emit('centerDrawer')
  }
  confirm() {
    this.selectedRowKeys = []
    this.selectNUmber = 0
    this.$emit('confirmTopic', this.chosenTopics)
  }
}
